import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string; // path relative to src/images/, e.g. "homepage/hero.jpg"
  alt: string;
  style?: React.CSSProperties;
  height?: number;
  width?: number;
  loading?: 'eager' | 'lazy';
  maxWidth?: number;
};

const LocalImage = ({ src, alt, style, height, width, loading }: Props) => {
  const { allFile } = useStaticQuery<{
    allFile: { nodes: { relativePath: string; publicURL: string }[] };
  }>(graphql`
    query LocalImageFiles {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        nodes {
          relativePath
          publicURL
        }
      }
    }
  `);

  const file = allFile.nodes.find((n) => n.relativePath === src);

  return (
    <img
      src={file?.publicURL}
      alt={alt}
      className="img-fluid"
      height={height}
      width={width}
      loading={loading}
      style={style}
    />
  );
};

export default LocalImage;
